// extracted by mini-css-extract-plugin
export default {"forgotPassword":"ForgotPassword_forgotPassword__6cR3i","helpText":"ForgotPassword_helpText__kgtZ0","supportLink":"ForgotPassword_supportLink__i1h9u"};